import { createStore } from 'vuex'
import { setSecretKey } from '@/api/secret'

export default createStore({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {
      username: '',
      mobile: '',
      avatar: ''
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {
        username: '',
        mobile: '',
        avatar: ''
      }
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userPhone')
      localStorage.removeItem('userToken')
      setSecretKey(null)
    }
  },
  actions: {
    login({ commit }, userInfo) {
      return new Promise((resolve) => {
        // 从 userInfo 中获取真实的 token（如果存在）
        const token = userInfo.token || localStorage.getItem('userToken') || ""

        // 清理手机号中的空格
        const cleanPhone = userInfo.username.replace(/\s/g, '');

        // 保存基本的登录信息（后续会被完整的用户信息覆盖）
        const basicUser = {
          username: cleanPhone, // 使用手机号作为用户名
          mobile: cleanPhone // 保存清理后的手机号
        }
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', basicUser)
        if (userInfo.secret_key) {
          setSecretKey(userInfo.secret_key)
        }
        resolve()
      })
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
})
